import {create} from "zustand";

export type ZstdLanguage = {

  language: string;

};
export const useZstdLanguage = create<ZstdLanguage>((set) => ({
  language: ''
}));
